import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useGlobalContext } from '../../../../context/GlobalContext';
import { stopScroll } from '../../../../utils/autoScrollHelpers';
import { scrollTop } from '../../../../utils/utilities';

import Modal from '../../../../components/common/Modal';
import ModalButton from '../../../../components/common/ModalButton';
import Icon from '../../../../components/common/Icon';
import ServiceSongList from '../../../../components/ServiceSongList';
import { ReactComponent as ExitIcon } from '../../../../icons/log-out.svg';

import './SongListModal.scss';

// The service's songs off the song view's 1/5 pill — the same list a service card opens, with the way out
const SongListModal = ({ isOpen, onClose, title, songs, currentSongIndex, onSongSelect }) => {
  const { t } = useTranslation();
  const { scrollTimerRef, setIsScrolling } = useGlobalContext();
  const history = useHistory();

  const handleSongSelect = (index) => {
    stopScroll(scrollTimerRef, setIsScrolling);
    onSongSelect(index);
    onClose();
  };

  const handleExit = () => {
    stopScroll(scrollTimerRef, setIsScrolling);
    history.push('/');
    onClose();
    scrollTop(undefined, false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      className="SongListModal"
      footer={
        <ModalButton variant="secondary" block className="exit" onClick={handleExit}>
          <Icon icon={<ExitIcon />} /> {t('view.exitService')}
        </ModalButton>
      }
    >
      <ServiceSongList
        entries={songs.map((song, i) => ({ song, i }))}
        currentIndex={currentSongIndex}
        onSelect={handleSongSelect}
      />
    </Modal>
  );
};

SongListModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  songs: PropTypes.array.isRequired,
  currentSongIndex: PropTypes.number.isRequired,
  onSongSelect: PropTypes.func.isRequired,
};

export default SongListModal;
